import React from 'react'
import { Box, capitalize, Chip, Grid } from '@mui/material'
import { formatDate, formatProductsUnits } from '@ui-seeker/utils'

import { AppLabelValueBlock } from '@components'
import { DAYS, RENTAL_DATES_OPTIONS } from '../../../../@constants'
import { dateFormatReceiver } from '@utils'
import NumSearchesBlock from 'Pages/ReportsAlerts/Reports/@components/NumSearchesBlock'

export default function ReportInfoModalDetails({ data }) {

	const {
		timeFrom, timeTo, rentalDateOption, rentalDateOptionTranslation, lengthOfRental, weekdayFilters, daysMonitorized,
		numSearches, idCurrencyTranslation, notificationEmail, specificDates, weekSelected, withinDays, daysSelected, nextFullMonth
	} = data
	const isSpecificDates = rentalDateOption === RENTAL_DATES_OPTIONS.SPECIFIC_DAYS
	const isLeadTimes = rentalDateOption === RENTAL_DATES_OPTIONS.LEAD_TIMES
	const isDayWeek = rentalDateOption === RENTAL_DATES_OPTIONS.DAY_SELECTED
	const isFullMonth = rentalDateOption === RENTAL_DATES_OPTIONS.FULL_MONTH

	return <Grid container spacing={2}>
		{!!timeFrom && <Grid item xs={12}>
            <AppLabelValueBlock label="Pickup time" value={timeFrom.length === 4 ? `0${timeFrom}` : timeFrom}/>
		</Grid>}

		{!!timeTo && <Grid item xs={12}>
            <AppLabelValueBlock label="Dropoff time" value={timeTo.length === 4 ? `0${timeTo}` : timeTo}/>
		</Grid>}

		<Grid item xs={12}>
			<AppLabelValueBlock
				label="Rental Date Option"
				value={rentalDateOptionTranslation && capitalize(rentalDateOptionTranslation)}/>
		</Grid>

		{!!isSpecificDates && <Grid item xs={12}>
			<AppLabelValueBlock label="Dates of rental" sxLabel={{ minWidth: '90px' }}
								sxContainer={{ alignItems: 'center' }}
								value={<Box>{specificDates?.sort()?.map((date, idx) => {
									return <Chip
										key={idx}
										color="secondary"
										label={formatDate(date.split("T")[0], {
											isString: true,
											receivedFormat: dateFormatReceiver(date.split("T")[0])
										})}
										sx={{ m: 0.25, p: 0.25 }}
									/>
								})}</Box>}/>
		</Grid>}

		{!!isLeadTimes && <Grid item xs={12}>
			<AppLabelValueBlock label="Within days" sxContainer={{ alignItems: 'center' }}
								value={<Box>{withinDays?.map((date, idx) => <Chip
									key={idx}
									color="secondary"
									label={formatProductsUnits(date)}
									sx={{ m: 0.25, p: 0.25 }}
								/>)}</Box>}/>
		</Grid>}

		{!!isDayWeek && <Grid item xs={12}>
			<AppLabelValueBlock label="Days" sxContainer={{ alignItems: 'center' }}
								value={<Box>{daysSelected?.map((day, idx) => {
									return <Chip
										key={day}
										color="secondary"
										label={`${DAYS[day]}`}
										sx={{ m: 0.25, p: 0.25 }}
									/>
								})}</Box>}/>
		</Grid>}

		{!!isDayWeek && <Grid item xs={12}>
			<AppLabelValueBlock label="Weeks" sxContainer={{ alignItems: 'center' }}
								value={<Box>{weekSelected?.map((date, idx) => <Chip
									key={idx}
									color="secondary"
									label={formatProductsUnits(date)}
									sx={{ m: 0.25, p: 0.25 }}
								/>)}</Box>}/>
		</Grid>}

		{!!isFullMonth && <Grid item xs={12}>
			<AppLabelValueBlock label="Next Full Months" sxContainer={{ alignItems: 'center' }}
								value={<Box>{nextFullMonth?.map((date, idx) => <Chip
									key={idx}
									color="secondary"
									label={formatProductsUnits(date)}
									sx={{ m: 0.25, p: 0.25 }}
								/>)}</Box>}/>
		</Grid>}

		{!!lengthOfRental?.length && <Grid item xs={12}>
			<AppLabelValueBlock label="Length of rental" sxContainer={{ alignItems: 'center' }}
								value={<Box>{lengthOfRental?.map((day, idx) => <Chip
									key={idx}
									color="secondary"
									label={day}
									sx={{ m: 0.25, p: 0.25 }}
								/>)}</Box>}/>
		</Grid>}

		{!!weekdayFilters?.length && <Grid item xs={12}>
			<AppLabelValueBlock label="Filter per day of the week" sxContainer={{ alignItems: 'center' }}
								value={<Box>{weekdayFilters?.map((day, idx) => <Chip
									key={idx}
									color="secondary"
									label={day}
									sx={{ m: 0.25, p: 0.25 }}
								/>)}</Box>}/>
		</Grid>}

		{!!daysMonitorized && <>
			<Grid item xs={12}>
				<AppLabelValueBlock label="Number of days to monitor" value={formatProductsUnits(daysMonitorized)}/>
			</Grid>
		</>
		}

		<Grid item xs={12}>
			<AppLabelValueBlock label="Nº searches" value={<NumSearchesBlock numSearches={numSearches}/>}/>
		</Grid>

		<Grid item xs={12}>
			<AppLabelValueBlock label="Send notification to" sxLabel={{ minWidth: '120px' }}
								sxContainer={{ alignItems: 'center' }}
								value={<Box>{notificationEmail?.map((email, idx) => <Chip
									key={idx}
									color="secondary"
									label={email}
									sx={{ m: 0.25, p: 0.25 }}
								/>)}</Box>}/>
		</Grid>

		<Grid item xs={12}>
			<AppLabelValueBlock label="Currency" value={idCurrencyTranslation}/>
		</Grid>
	</Grid>
}